const brandConfig = {
  brandName: "anackmira",
  brandInitial: "A",
  legalName: "SPRAYJOY LIMITED",
  description:
    "Original browser games you can try instantly and unlock locally.",
  email: "debit@anackmira.store",
  website: "anackmira.store",
  websiteUrl: "https://anackmira.store",
  address: "UNIT 1603, 16/F THE L. PLAZA\n367-375 QUEEN'S RD CENTRAL\nSHEUNG WAN\nHONG KONG",
  currency: "USD",
  locale: "en-US",
  navigation: [
    { label: "Games", to: "/shop" },
    { label: "About", to: "/about" },
    { label: "FAQs", to: "/faqs" },
    { label: "Contact", to: "/contact" },
  ],
  footerLinks: [
    { label: "Privacy", to: "/privacy" },
    { label: "Terms", to: "/terms" },
    { label: "Refunds", to: "/returns" },
    { label: "Digital delivery", to: "/shipping" },
  ],
};

export default brandConfig;
